// Discipline action types
export const INITIALIZE_DISCIPLINES = 'INITIALIZE_DISCIPLINES';
export const ADD_DISCIPLINE = 'ADD_DISCIPLINE';
export const UPDATE_DISCIPLINE = 'UPDATE_DISCIPLINE';
export const DELETE_DISCIPLINE = 'DELETE_DISCIPLINE';
export const CLEAR_DISCIPLINES_LIST = 'CLEAR_DISCIPLINES_LIST';

// Unit action types
export const INITIALIZE_UNITS = 'INITIALIZE_UNITS';
export const ADD_UNIT = 'ADD_UNIT';
export const UPDATE_UNIT = 'UPDATE_UNIT';
export const DELETE_UNIT = 'DELETE_UNIT';
export const CLEAR_UNITS_LIST = 'CLEAR_UNITS_LIST';

// Skill action types
export const INITIALIZE_SKILLS = 'INITIALIZE_SKILLS';
export const ADD_SKILL = 'ADD_SKILL';
export const UPDATE_SKILL = 'UPDATE_SKILL';
export const DELETE_SKILL = 'DELETE_SKILL';
export const CLEAR_SKILLS_LIST = 'CLEAR_SKILLS_LIST';

// Roles actions
export const INITIALIZE_ROLES = 'INITIALIZE_ROLES';
export const ADD_ROLE = 'ADD_ROLE';
export const DELETE_ROLE = 'DELETE_ROLE';
export const UPDATE_ROLE = 'UPDATE_ROLE';
export const CLEAR_ROLES_LIST = 'CLEAR_ROLES_LIST';
export const ASSIGN_PERMISSIONS_TO_ROLE = 'ASSIGN_PERMISSIONS_TO_ROLE';
export const ASSIGN_ROLES_TO_USERS = 'ASSIGN_ROLES_TO_USERS';


//Poste action types
export const INITIALIZE_POSTES = 'INITIALIZE_POSTES';
export const ADD_POSTE = 'ADD_POSTE';
export const UPDATE_POSTE = 'UPDATE_POSTE';
export const DELETE_POSTE = 'DELETE_POSTE';

export const ASSIGN_POSTE_TO_DISCIPLINE = 'ASSIGN_POSTE_TO_DISCIPLINE';
export const CLEAR_POSTES_LIST = 'CLEAR_POSTES_LIST';

//Employee action types

export const INITIALIZE_EMPLOYEES = 'INITIALIZE_EMPLOYEES';
export const ADD_EMPLOYEE = 'ADD_EMPLOYEE';
export const UPDATE_EMPLOYEE = 'UPDATE_EMPLOYEE';
export const DELETE_EMPLOYEE = 'DELETE_EMPLOYEE';
export const CLEAR_EMPLOYEES_LIST = 'CLEAR_EMPLOYEES_LIST';
export const RESTORE_EMPLOYEE = 'RESTORE_EMPLOYEE';
export const ASSIGN_PERMISSIONS_TO_EMPLOYEE = 'ASSIGN_PERMISSIONS_TO_EMPLOYEE';
export const ASSIGN_POSTE_TO_EMPLOYEE = 'ASSIGN_POSTE_TO_EMPLOYEE';

//Evaluation action types
export const INITIALIZE_EVALUATIONS = 'INITIALIZE_EVALUATIONS';
export const ADD_EVALUATION = 'ADD_EVALUATION';
export const UPDATE_EVALUATION = 'UPDATE_EVALUATION';
export const DELETE_EVALUATION = 'DELETE_EVALUATION';
export const CLEAR_EVALUATIONS_LIST = 'CLEAR_EVALUATIONS_LIST';
export const ADD_EVALUATION_TO_EMPLOYEE = 'ADD_EVALUATION_TO_EMPLOYEE';

// Notification actions
export const ADD_NOTIFICATION = "ADD_NOTIFICATION";
export const DELETE_NOTIFICATION = "DELETE_NOTIFICATION";
export const CLEAR_NOTIFICATIONS_LIST = "CLEAR_NOTIFICATIONS_LIST";
export const MARK_SEEN_NOTIFICATION = "MARK_SEEN_NOTIFICATION";
export const MARK_UNSEEN_NOTIFICATION = "MARK_UNSEEN_NOTIFICATION";
export const MARK_ALL_SEEN_NOTIFICATIONS = "MARK_ALL_SEEN_NOTIFICATIONS";

// User Companies actions
export const INITIALIZE_USER_COMPANIES = 'INITIALIZE_USER_COMPANIES';
export const ADD_USER_COMPANY = 'ADD_USER_COMPANY';
export const DELETE_USER_COMPANY = 'DELETE_USER_COMPANY';
export const UPDATE_USER_COMPANY = 'UPDATE_USER_COMPANY';
export const CLEAR_USER_COMPANIES_LIST = 'CLEAR_USER_COMPANIES_LIST';
export const RESTORE_USER_COMPANY = 'RESTORE_USER_COMPANY';
export const ASSIGN_PERMISSIONS_TO_USER_COMPANY = 'ASSIGN_PERMISSIONS_TO_USER_COMPANY';
export const ASSIGN_POSTE_TO_USER_COMPANY = 'ASSIGN_POSTE_TO_USER_COMPANY';


// Requirement Skills action types
export const INITIALIZE_REQUIREMENTS = 'INITIALIZE_REQUIREMENTS';
export const ADD_REQUIREMENT = 'ADD_REQUIREMENT';
export const UPDATE_REQUIREMENT = 'UPDATE_REQUIREMENT';
export const DELETE_REQUIREMENT = 'DELETE_REQUIREMENT';
export const CLEAR_REQUIREMENTS_LIST = 'CLEAR_REQUIREMENTS_LIST';

// Rater Type action types
export const INITIALIZE_RATER_TYPES = 'INITIALIZE_RATER_TYPES';
export const ADD_RATER_TYPE = 'ADD_RATER_TYPE';
export const UPDATE_RATER_TYPE = 'UPDATE_RATER_TYPE';
export const DELETE_RATER_TYPE = 'DELETE_RATER_TYPE';
export const CLEAR_RATER_TYPES_LIST = 'CLEAR_RATER_TYPES_LIST';

// Practical Evidence action types
export const INITIALIZE_PRACTICAL_EVIDENCES = 'INITIALIZE_PRACTICAL_EVIDENCES';
export const ADD_PRACTICAL_EVIDENCE = 'ADD_PRACTICAL_EVIDENCE';
export const UPDATE_PRACTICAL_EVIDENCE = 'UPDATE_PRACTICAL_EVIDENCE';
export const DELETE_PRACTICAL_EVIDENCE = 'DELETE_PRACTICAL_EVIDENCE';
export const CLEAR_PRACTICAL_EVIDENCES_LIST = 'CLEAR_PRACTICAL_EVIDENCES_LIST';
export const APPROVE_PRACTICAL_EVIDENCE = 'APPROVE_PRACTICAL_EVIDENCE';
export const REJECT_PRACTICAL_EVIDENCE = 'REJECT_PRACTICAL_EVIDENCE';

// Quiz action types
export const INITIALIZE_QUIZZES = 'INITIALIZE_QUIZZES';
export const ADD_QUIZ = 'ADD_QUIZ';
export const UPDATE_QUIZ = 'UPDATE_QUIZ';
export const DELETE_QUIZ = 'DELETE_QUIZ';
export const CLEAR_QUIZZES_LIST = 'CLEAR_QUIZZES_LIST';

// Quiz Attempts action types
export const INITIALIZE_QUIZ_ATTEMPTS = 'INITIALIZE_QUIZ_ATTEMPTS';
export const ADD_QUIZ_ATTEMPT = 'ADD_QUIZ_ATTEMPT';
export const UPDATE_QUIZ_ATTEMPT = 'UPDATE_QUIZ_ATTEMPT';
export const DELETE_QUIZ_ATTEMPT = 'DELETE_QUIZ_ATTEMPT';
export const CLEAR_QUIZ_ATTEMPTS = 'CLEAR_QUIZ_ATTEMPTS';

// Quiz Responses action types
export const INITIALIZE_QUIZ_RESPONSES = 'INITIALIZE_QUIZ_RESPONSES';
export const ADD_QUIZ_RESPONSE = 'ADD_QUIZ_RESPONSE';
export const UPDATE_QUIZ_RESPONSE = 'UPDATE_QUIZ_RESPONSE';
export const DELETE_QUIZ_RESPONSE = 'DELETE_QUIZ_RESPONSE';
export const CLEAR_QUIZ_RESPONSES = 'CLEAR_QUIZ_RESPONSES';

// Quiz Question action types
export const INITIALIZE_QUIZ_QUESTIONS = 'INITIALIZE_QUIZ_QUESTIONS';
export const ADD_QUIZ_QUESTION = 'ADD_QUIZ_QUESTION';
export const UPDATE_QUIZ_QUESTION = 'UPDATE_QUIZ_QUESTION';
export const DELETE_QUIZ_QUESTION = 'DELETE_QUIZ_QUESTION';
export const CLEAR_QUIZ_QUESTIONS = 'CLEAR_QUIZ_QUESTIONS';

// Question Option action types
export const INITIALIZE_QUESTION_OPTIONS = 'INITIALIZE_QUESTION_OPTIONS';
export const ADD_QUESTION_OPTION = 'ADD_QUESTION_OPTION';
export const UPDATE_QUESTION_OPTION = 'UPDATE_QUESTION_OPTION';
export const DELETE_QUESTION_OPTION = 'DELETE_QUESTION_OPTION';
export const CLEAR_QUESTION_OPTIONS = 'CLEAR_QUESTION_OPTIONS';

// Quiz Assignment action types
export const INITIALIZE_QUIZ_ASSIGNMENTS = 'INITIALIZE_QUIZ_ASSIGNMENTS';
export const ADD_QUIZ_ASSIGNMENT = 'ADD_QUIZ_ASSIGNMENT';
export const UPDATE_QUIZ_ASSIGNMENT = 'UPDATE_QUIZ_ASSIGNMENT';
export const DELETE_QUIZ_ASSIGNMENT = 'DELETE_QUIZ_ASSIGNMENT';
export const CLEAR_QUIZ_ASSIGNMENTS = 'CLEAR_QUIZ_ASSIGNMENTS';
export const REVOKE_QUIZ_ASSIGNMENT = 'REVOKE_QUIZ_ASSIGNMENT';


